import { Box, Flex, Heading, SkeletonText } from "@chakra-ui/react";
import { StatsGrid } from "components/stats-grid";
import { useFormatMoneyCentsConverter } from "hooks/use-format-money";
import type { FinancialsOverviewData } from "modules/landlord-portal/models/financials";

type FinancialSnapshotBoxProps = {
  isLoading: boolean;
  summary?: FinancialsOverviewData["financial_snapshot"];
};
export function FinancialSnapshotBox({
  isLoading,
  summary,
}: FinancialSnapshotBoxProps) {
  const formatMoney = useFormatMoneyCentsConverter();

  return (
    <Box
      p={6}
      bg={"white"}
      gap={6}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"space-between"}
      borderRadius={"lg"}
    >
      <Flex direction={"column"} gap={1}>
        <Heading size={"md"}>Your financial snapshot</Heading>
        {isLoading && (
          <SkeletonText noOfLines={1} w={"50%"} skeletonHeight={5} h={"21px"} />
        )}
      </Flex>
      <StatsGrid
        isLoading={isLoading}
        stats={
          summary
            ? [
                {
                  id: "available_client_balance",
                  label: "Available Client Balance",
                  value: formatMoney(summary.available_client_balance),
                },
                {
                  id: "invoices_receivable",
                  label: "Invoices Receivable",
                  value: formatMoney(summary.invoices_receivable),
                },
                {
                  id: "bills_payable",
                  label: "Bills Payable",
                  value: formatMoney(summary.bills_payable),
                },
                {
                  id: "pending_agency_fees",
                  label: "Pending Agency Fees",
                  value: formatMoney(summary.pending_agency_fees),
                },
              ]
            : []
        }
        hasIcons={false}
        columnsLarge={3}
        columnsSmall={3}
      />
    </Box>
  );
}
